
import dayjs from "dayjs";
import {
  MenuIcon,
  ChevronDownIcon,
  UserIcon,
  CogIcon,
  XIcon,
  CalendarIcon,
  DatabaseIcon,
  PresentationChartLineIcon,
  UserGroupIcon,
  TemplateIcon,
  LogoutIcon,
} from "@vue-hero-icons/outline";
import { CONTANTS, CONTANTS_EN } from "~/constants";
const AuthButtons = () => import("~/components/Cafe/AuthButtons.vue");

export default {
  components: {
    MenuIcon,
    ChevronDownIcon,
    UserIcon,
    CogIcon,
    XIcon,
    CalendarIcon,
    DatabaseIcon,
    PresentationChartLineIcon,
    UserGroupIcon,
    TemplateIcon,
    LogoutIcon,
    AuthButtons,
  },

  props: {
    item: {
      type: Object,
      default: undefined,
    },
  },

  fetchOnServer: false,

  data() {
    return {
      data: {},
      activeMenu: false,
    };
  },

  computed: {
    customer() {
      return this.$get(this.$$users, "user", "");
    },

    customerType() {
      return this.$get(this.$$users, "type", "google");
    },

    userPlanExpiration() {
      const expired = this.$get(this.$$subscriptions, "current_period_end", "");

      if (!expired) return "MM/DD/YYYY";

      return dayjs(expired).format("MM/DD/YYYY");
    },

    userPlanActive() {
      return this.$get(this.$$subscriptions, "status") === 'active';
    },

    userPlan() {
      return this.userPlanActive ? "PRO" : "FREE";
    },

    activeMenuClass() {
      return this.activeMenu ? "active" : "";
    },
  },

  methods: {
    isRouteActive(keyword) {
      if (this.$route.path.includes(keyword)) {
        return true;
      } else {
        return false;
      }
    },

    closeMenu() {
      this.activeMenu = false;
    },

    toggleMenu() {
      this.activeMenu = !this.activeMenu;
    },

    async logout() {
      const message = this.$t("common.signout_msg");
      const confirm = await this.$vmodal.confirm({ message });
      if (!confirm) {
        return;
      }

      if (!this.customer || !this.customerType) {
        return;
      }

      if (this.customerType == "facebook") {
        this.$store.dispatch("auth/logout");
        this.$$FB.getLoginStatus((responseStatus) => {
          if (responseStatus.status === "connected") {
            this.$$FB.logout((response) => {
              this.$router.push("/");
            });
          }
        });
        this.$router.push("/");
      } else if (this.customerType == "google") {
        this.$store.dispatch("auth/logout");
        this.$router.push("/");
      }
    },
  },
};
